import React from "react";
import InfoRow from "../InfoRow";

const StaffDetails = ({ staff }) => {
	return (
		<div className="tw-flex tw-flex-col tw-gap-4">
			<div className="tw-rounded-xl tw-px-6 tw-py-5 tw-grid tw-gap-1" style={{ boxShadow: "0px 0px 14.5px 0px rgba(0, 0, 0, 0.1)" }}>
				<InfoRow title="Storefront:">Ikeja Storefront</InfoRow>
				<InfoRow title="Role:">Manager</InfoRow>
			</div>
			<div className="tw-rounded-xl tw-px-6 tw-py-5 tw-grid tw-gap-1" style={{ boxShadow: "0px 0px 14.5px 0px rgba(0, 0, 0, 0.1)" }}>
				<InfoRow title="First Name:">{staff?.first_name}</InfoRow>
				<InfoRow title="Last Name:">{staff?.last_name}</InfoRow>
				<InfoRow title="Email Address:">{staff?.email}</InfoRow>
				<InfoRow title="Phone Number:">{staff?.phone}</InfoRow>
			</div>
		</div>
	);
};

export default StaffDetails;
